import * as ProgressPrimitive from '@radix-ui/react-progress';

import { ColorOrCustom, cn, resolveColorClass } from 'styles';

export interface LinerProgressProps {
  value: number;
  className?: string;
  rounded?: boolean;
  color?: ColorOrCustom;
  trackClassName?: string;
}

export function LinearProgress({
  className,
  value,
  rounded,
  color,
  trackClassName,
  ...props
}: LinerProgressProps): JSX.Element {
  return (
    <ProgressPrimitive.Root
      className={cn('relative h-3 w-full overflow-hidden rounded-full bg-secondary', className)}
      {...props}
    >
      <ProgressPrimitive.Indicator
        style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
        className={cn(
          'h-full w-full flex-1 shrink-0 transition-all',
          resolveColorClass(color ?? 'primary', 'bg'),
          rounded && 'rounded-full',
          trackClassName,
        )}
      />
    </ProgressPrimitive.Root>
  );
}
